var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import { postWithAuthn } from "../RequestHelpers";
var UploadFileModal = /** @class */ (function (_super) {
    __extends(UploadFileModal, _super);
    function UploadFileModal(props) {
        var _this = _super.call(this, props) || this;
        _this.addAttachment = function (event, _) {
            var _a;
            var attachment = (_a = event.currentTarget.files) === null || _a === void 0 ? void 0 : _a[0];
            _this.setState({
                attachment: attachment
            });
        };
        _this.removeAttachment = function () {
            _this.setState({
                attachment: undefined
            });
        };
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
            }, function () {
                var formData = new FormData();
                formData.append('attachment', _this.state.attachment);
                postWithAuthn("" + _this.props.path, formData)
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: [],
                            attachment: undefined
                        });
                        return;
                    }
                    else if (resp.status === 400) {
                        return resp.json();
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }]
                        });
                        return;
                    }
                })
                    .then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            loading: false,
                            errors: resp.errors,
                            success: false
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't Upload Attachment: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            attachment: undefined
        };
        return _this;
    }
    UploadFileModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.attachment ? "Selected attachment: " + this.state.attachment.name + " " +
                React.createElement(Button, { icon: "x", color: 'red', size: 'mini', onClick: this.removeAttachment })
                : 'No attachment selected',
            React.createElement("div", null,
                React.createElement(Input, { type: 'file', onChange: this.addAttachment, multiple: false })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Attachment uploaded."),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            React.createElement("br", null),
            React.createElement(Button, { disabled: this.state.success || this.state.attachment === undefined, icon: 'upload', label: 'Add Attachments', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return UploadFileModal;
}(React.PureComponent));
export default UploadFileModal;
;
//# sourceMappingURL=UploadFileModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/UploadFileModal.js
// module id = 104
// module chunks = 0